import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'
import TableCell from '@material-ui/core/TableCell'

const sortableHeader =
  (sortParam, selectedFilters) =>
  ({ index, label }, toggleSort) => {
    const isActive = selectedFilters.sortParam === sortParam

    return (
      <TableCell key={index} onClick={() => toggleSort(index)} style={{ cursor: 'pointer' }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}>
          {label}
          <span
            aria-label={isActive ? `Renditje ${selectedFilters.sortType === -1 ? 'zbritëse' : 'ngritëse'}` : 'Kolonë e renditshme'}
            style={{ display: 'inline-flex', alignItems: 'center' }}
          >
            {!isActive ? (
              <ArrowDownwardIcon style={{ fontSize: 17, opacity: 0.55 }} />
            ) : selectedFilters.sortType === -1 ? (
              <ArrowUpwardIcon color='primary' style={{ fontSize: 17 }} />
            ) : (
              <ArrowDownwardIcon color='primary' style={{ fontSize: 17 }} />
            )}
          </span>
        </span>
      </TableCell>
    )
  }

export const getColumns = (
  languages,
  roles,
  projects,
  departments,
  activities,
  workingStatus,
  offices,
  showFilters,
  renderFilters,
  selectedFilters
) => [
  {
    name: 'Email',
    label: 'Email',
    options: {
      filter: false,
      sort: true,
      customHeadRender: sortableHeader('email', selectedFilters)
    }
  },
  {
    name: 'Përdoruesi',
    label: 'Përdoruesi',
    options: {
      filter: false,
      sort: true,
      customHeadRender: sortableHeader('first_name', selectedFilters)
    }
  },
  {
    name: 'Gjuhet',
    label: 'Gjuhet',
    options: {
      filter: true,
      sort: true,
      customHeadRender: sortableHeader('languages._id.code', selectedFilters),
      display: showFilters.language,
      filterList: renderFilters.language,
      filterOptions: {
        names: languages.map((element) => element.code)
      }
    }
  },
  {
    name: 'Pozita',
    label: 'Pozita',
    options: {
      filter: true,
      sort: true,
      customHeadRender: sortableHeader('function.name', selectedFilters),
      filterList: renderFilters.function,
      filterOptions: {
        names: roles.map((element) => element.name)
      }
    }
  },
  {
    name: 'Projekti',
    label: 'Projekti',
    options: {
      filter: true,
      sort: true,
      customHeadRender: sortableHeader('project.name', selectedFilters),
      filterList: renderFilters.project,
      filterOptions: {
        names: projects.map((element) => element.name)
      }
    }
  },

  {
    name: 'Aktiviteti',
    label: 'Aktiviteti',
    options: {
      filter: true,
      sort: true,
      display: showFilters.activity,
      filterList: renderFilters.activity,
      filterOptions: {
        names: activities.map((element) => element.name)
      }
    }
  },
  {
    name: 'Statusi i punës',
    label: 'Statusi i punës',
    options: {
      filter: true,
      sort: false,
      display: showFilters.workingStatus,
      filterList: renderFilters.workingStatus,
      filterOptions: {
        names: workingStatus.map((element) => element.name)
      }
    }
  },
  {
    name: 'Leternjoftimi',
    label: 'Leternjoftimi',
    options: {
      filter: false,
      sort: true,
      display: showFilters.identityID
    }
  },
  {
    name: 'Krijuar ne',
    label: 'Krijuar ne',
    options: {
      filter: false,
      sort: true,
      display: showFilters.createdDate
    }
  },
  {
    name: 'Qyteti',
    label: 'Qyteti',
    options: {
      filter: false,
      sort: true,
      display: showFilters.city
    }
  },
  {
    name: 'Menaxheri',
    label: 'Menaxheri',
    options: {
      filter: false,
      sort: true,
      display: showFilters.manager
    }
  },
  {
    name: 'Team Leaderi',
    label: 'Team Leaderi',
    options: {
      filter: false,
      sort: true,
      display: showFilters.teamLeader
    }
  },
  {
    name: 'Lokacioni i punës',
    label: 'Lokacioni i punës',
    options: {
      filter: true,
      sort: true,
      customHeadRender: sortableHeader('office_location', selectedFilters),
      filterList: renderFilters.offices,
      filterOptions: {
        names: offices.map((office) => office)
      }
    }
  },
  {
    name: 'Departamenti',
    label: 'Departamenti',
    options: {
      filterType: 'checkbox',
      filter: true,
      sort: true,
      customHeadRender: sortableHeader('department.name', selectedFilters),
      display: showFilters.department,
      filterList: renderFilters.department,
      filterOptions: {
        names: departments.map((element) => element.name)
      }
    }
  },
  {
    name: 'Pamje',
    label: 'Pamje',
    options: {
      filter: false,
      sort: false
    }
  }
]
